import { render, staticRenderFns } from "./MobileDevices.vue?vue&type=template&id=3547f547&"
import script from "./MobileDevices.vue?vue&type=script&lang=js&"
export * from "./MobileDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports